import { Outlet, useLocation } from 'react-router-dom'
import { Navbar, Sidebar, Footer, Newsletter } from '@/components'
// Sometimes the newsletter is a modal; manage via context
import { useNewsletter } from '@/contexts/NewsletterContext'

const BaseLayout = () => {
    const location = useLocation();
    const { isOpen, closeNewsletter } = useNewsletter();
    const isDashboard = location.pathname.includes('/dashboard');
    const showNewsletter = location.pathname !== '/support' && !isDashboard;

    return (
        <div className="relative bg-gray-900 overflow-hidden min-h-screen w-full flex flex-col">
            <div className="w-[605px] h-[605px] left-[87px] top-[1509px] absolute opacity-30 bg-primary rounded-full blur-[282.13px]" />
            <div className="w-96 h-96 left-[-214px] top-[3077px] absolute opacity-30 bg-primary rounded-full blur-[247.13px]" />
            <div className="w-96 h-96 left-[1183px] top-[3057px] absolute opacity-60 bg-info rounded-full blur-[282.13px]" />
            <div className="w-[605px] h-[605px] left-[991px] top-[639px] absolute opacity-30 bg-primary rounded-full blur-[282.13px]" />
            <div className="w-96 h-96 left-[51px] top-[-229px] absolute opacity-60 bg-info rounded-full blur-[282.13px]" />
            
            <Navbar />
            
            {isDashboard && <Sidebar /> }
            
            <main className="flex-1">
                <Outlet />
            </main>
            
            {showNewsletter && <Newsletter />}
            {!showNewsletter && isOpen && (
                <div 
                    id="newsletterWrapper"
                    className="z-50 top-0 left-0 w-screen h-screen fixed bg-black/90 flex items-center justify-center"
                    onClick={closeNewsletter} // Close on backdrop click
                >
                    <div onClick={(e) => e.stopPropagation()}> {/* Prevent closing when clicking newsletter */}
                        <Newsletter
                            modalView={true}
                            onClose={closeNewsletter}    
                        />
                    </div>
                </div>
            )}
            {!isDashboard && <Footer />}
        </div>
    )
}

export default BaseLayout